// ─── Paystack Utility ─────────────────────────────────────────────────────────
// Paystack charges in kobo (smallest Nigerian currency unit).
// 1 NGN = 100 kobo. Multiply price by 100 before sending to Paystack.

export function loadPaystackScript() {
  return new Promise((resolve) => {
    if (typeof window !== "undefined" && window.PaystackPop) {
      return resolve(true);
    }
    const existing = document.querySelector('script[src*="paystack"]');
    if (existing) {
      existing.addEventListener("load", () => resolve(!!window.PaystackPop));
      existing.addEventListener("error", () => resolve(false));
      setTimeout(() => resolve(!!window.PaystackPop), 1500);
      return;
    }
    const script = document.createElement("script");
    script.src = "https://js.paystack.co/v1/inline.js";
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

export async function initializePaystack({ email, amount, onSuccess, onClose, metadata = {} }) {
  const FALLBACK_KEY = "pk_live_17b9284e8e4e4333a1ab0479130f01a63ac29a60";
  const PAYSTACK_KEY = (process.env.REACT_APP_PAYSTACK_PUBLIC_KEY || FALLBACK_KEY).trim();

  if (!PAYSTACK_KEY || PAYSTACK_KEY.startsWith("your_")) {
    throw new Error("Paystack public key is not configured. Please set REACT_APP_PAYSTACK_PUBLIC_KEY in your hosting environment.");
  }

  // Ensure Paystack inline script is loaded
  if (typeof window !== "undefined" && !window.PaystackPop) {
    const loaded = await loadPaystackScript();
    if (!loaded || !window.PaystackPop) {
      throw new Error("Paystack payment gateway could not be loaded. Please check your internet connection or disable ad blockers.");
    }
  }

  const koboAmount = Math.round(Number(amount) * 100);
  if (isNaN(koboAmount) || koboAmount <= 0) {
    throw new Error("Invalid payment amount. Grand total must be greater than zero.");
  }

  const handler = window.PaystackPop.setup({
    key: PAYSTACK_KEY,
    email: email.trim(),
    amount: koboAmount,
    currency: "NGN",
    ref: `AFRIPORT-${Date.now()}-${Math.random().toString(36).slice(2, 8).toUpperCase()}`,
    metadata,
    callback: function (response) {
      if (typeof onSuccess === "function") {
        onSuccess(response);
      }
    },
    onClose: function () {
      if (typeof onClose === "function") {
        onClose();
      }
    },
  });

  handler.openIframe();
}

